import { render, staticRenderFns } from "./r-item-shop-product-dialog.vue?vue&type=template&id=5e91bc78&scoped=true"
import script from "./r-item-shop-product-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-shop-product-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-shop-product-dialog.vue?vue&type=style&index=0&id=5e91bc78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e91bc78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e91bc78')) {
      api.createRecord('5e91bc78', component.options)
    } else {
      api.reload('5e91bc78', component.options)
    }
    module.hot.accept("./r-item-shop-product-dialog.vue?vue&type=template&id=5e91bc78&scoped=true", function () {
      api.rerender('5e91bc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-shop/r-item-shop-product-dialog.vue"
export default component.exports